import { translate } from "../Locales/translator";
import { AbstractCrossDateFieldValidation } from "./AbstractCrossDateFieldValidation";
import { CustomErrorMessage } from "./ValidationHelper";

export class StartDateLessOrEqualToEndDateValidation extends AbstractCrossDateFieldValidation {
  validateDates(startDate: Date, endDate: Date): boolean {
    return startDate <= endDate;
  }
  constructor(datumTmProperty: string, datumTmLabel: string, customErrorMessage?: CustomErrorMessage) {
    super(datumTmProperty, datumTmLabel, customErrorMessage);
  }

  defaultMessage = (label: string) =>
    translate("Generation_Form_{label}MoetKleinerOfGelijkZijnAan{datumTmLabel}", {label: label, datumTmLabel: this.datumTmLabel});

  key = "StartDateLessOrEqualToEndDateValidation";
}
